module.exports = __webpack_public_path__ + "static/media/169.8af45e3a.jpg";